import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token as a fallback (cross-site cookies can be blocked).
// Also send X-Requested-With so the backend can distinguish first-party XHR
// from a cross-site CSRF form submission.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Requested-With"] = "XMLHttpRequest";
  return config;
});

export function formatApiError(err) {
  // Network / no-response (backend restart, 502/503/504 gateway, offline)
  if (!err?.response) {
    return "Can't reach the server right now. Please try again in a moment.";
  }
  const status = err.response.status;
  if (status >= 502 && status <= 504) {
    return "Server is warming up. Please try again in a few seconds.";
  }
  const detail = err.response.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  if (typeof detail?.message === "string") return detail.message;
  return String(detail);
}

export default api;
